import AffiliateNotificationsToken from '@apps/maha/admin/tokens/affiliate_notifications'
import ShortLink from '@admin/components/shortlink'
import Details from '@admin/components/details'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import Edit from '../edit'
import React from 'react'

const Overview = ({ affiliate }) => {

  const shortlink = {
    shortlink: affiliate.shortlink,
    text: 't(Share this signup page)',
    title: 't(Affiliate Signup Page)'
  }

  const details = {
    audits: `maha_affiliates/${affiliate.id}`,
    comments: `maha_affiliates/${affiliate.id}`,
    before: <ShortLink { ...shortlink } />,
    sections: [
      {
        title: 't(Affiliate)',
        items: [
          { label: 't(Team)', content: affiliate.team.title },
          { label: 't(Active Referrals)', content: (
            <>{affiliate.active_referrals_count} / {affiliate.referrals_count}</>
          ) },
          ...(affiliate.stripe_bank_account_id ? [
            { label: 't(Bank Account)', content: `${affiliate.bank_name} - ${affiliate.bank_last_four}` }
          ] : [
            { label: 't(Bank Account)', content: 't(Not connected)' }
          ]),
          { label: 't(Agreed to Terms)', content: affiliate.agreed_to_terms, format: 'yes_no' },
          { label: 't(Commission Rate)', content: affiliate.rate, format: 'rate' },
          { label: 't(Notifications)', content: <AffiliateNotificationsToken value={ affiliate.notifications } /> }
        ]
      }
    ]
  }

  if(affiliate.deleted_at) {
    details.alert = { color: 'red', message: 't(This affiliate was deleted)' }
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  affiliate: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview affiliate={ props.affiliate } />,
  tasks: {
    items: [
      {
        label: 't(Edit Affiliate)',
        svg: 'square_pen',
        modal: <Edit affiliate={ props.affiliate } />
      },
      {
        label: 't(Delete Affiliate)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this affiliate?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/affiliates/${props.affiliate.id}`,
          method: 'DELETE',
          onSuccess: () => {
            context.flash.set('success', 't(Successfully deleted affiliate)')
            context.router.goBack()
          },
          onFailure: () => context.flash.set('error', 't(Unable to delete affiliate)')
        }
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
